import { style } from '@primeuix/styles/checkboxgroup';
import BaseStyle from '@primevue/core/base/style';

var classes = {
  root: 'p-checkbox-group p-component'
};
var CheckboxGroupStyle = BaseStyle.extend({
  name: 'checkboxgroup',
  style: style,
  classes: classes
});

export { CheckboxGroupStyle as default };
//# sourceMappingURL=index.mjs.map
